if (!customElements.get("product-bulk-subscription-options")) {
  customElements.define(
    "product-bulk-subscription-options",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.form = this.closest("form");
        if (!this.form) return;
        this.variantSelect = this.querySelector("[data-variant-select]");
        this.once = this.querySelector("[data-once]");
        this.offers = [...this.querySelectorAll("[data-offer]")];
        const url = new URL(window.location.href);
        const linkedPlan = this.offers.find(
          (offer) =>
            offer.value === url.searchParams.get("selling_plan") &&
            offer.dataset.variant === this.form.elements.id.value &&
            !offer.disabled,
        );
        if (linkedPlan) linkedPlan.checked = true;
        else if (this.dataset.requiresPlan === "true") {
          const available = this.offers.find((offer) => !offer.disabled);
          if (available) available.checked = true;
        }
        this.addEventListener(
          "change",
          (event) => {
            if (event.target.matches("[data-variant-select]") && this.once) {
              this.once.checked = true;
            }
            if (
              event.target.matches(
                "[data-variant-select], [data-offer], [data-once]",
              )
            ) {
              this.updatePurchase(true);
            }
          },
          { signal: this.controller.signal },
        );
        this.updatePurchase(false);
      }
      updatePurchase(updateUrl) {
        const offer = this.offers.find((input) => input.checked);
        const option = this.variantSelect?.selectedOptions[0];
        const selection = offer || (this.once?.checked ? option : null);
        const submit = this.form.querySelector('[type="submit"]');
        const planInput = this.form.querySelector('[name="selling_plan"]');
        const billing = this.querySelector("[data-billing]");
        const available = selection?.dataset.available === "true";
        submit.disabled = !available;
        submit.removeAttribute("aria-disabled");
        this.closest("product-form")?.handleErrorMessage?.();
        if (!selection) return;
        this.form.elements.id.value = offer
          ? offer.dataset.variant
          : option.value;
        this.form.elements.id.disabled = !available;
        this.form.elements.quantity.value = selection.dataset.quantity;
        planInput.disabled = !offer;
        planInput.value = offer ? offer.value : "";
        submit.querySelector("span").textContent = available
          ? `${window.variantStrings.addToCart} — ${selection.dataset.price}`
          : window.variantStrings.soldOut;
        if (option)
          this.querySelector("[data-once-unit-price]").textContent =
            option.dataset.unitPrice;
        billing.hidden = !offer;
        billing.textContent = offer
          ? `${offer.dataset.price} · ${offer.dataset.interval}`
          : "";
        const quantity = Number(selection.dataset.quantity);
        if (quantity > 1) {
          billing.hidden = false;
          billing.textContent += ` Minimum quantity: ${quantity}. Price shown per pack.`;
        }
        const productInfo = this.closest("product-info");
        const pickup = productInfo?.querySelector("pickup-availability");
        if (available) pickup?.fetchAvailability?.(this.form.elements.id.value);
        else pickup?.removeAttribute("available");
        const mediaId = selection.dataset.media;
        if (mediaId && updateUrl) {
          productInfo?.querySelector("media-gallery")?.setActiveMedia(`${this.dataset.section}-${mediaId}`, true);
        }
        if (updateUrl && !this.closest("quick-add-modal")) {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", this.form.elements.id.value);
          if (offer) url.searchParams.set("selling_plan", offer.value);
          else url.searchParams.delete("selling_plan");
          window.history.replaceState({}, "", url);
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    },
  );
}
